import type { LucideIcon, LucideProps } from "lucide-react"

export type Icon = LucideIcon

export const Icons = {
	logo: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={95}
			height={30}
			fill="none"
			role={"img"}
			aria-hidden={true}
			{...props}
		>
			<g clipPath="url(#a)">
				<path
					fill="#191919"
					d="M39.138 8.287v12.565c0 .439.088.756.264.951.19.195.497.293.922.293h5.202l.154 2.83c-1.478.179-3.615.269-6.41.269-1.17 0-2.041-.326-2.612-.976-.57-.651-.856-1.521-.856-2.611V8.287h3.336ZM52.446 12.752c2.02 0 3.446.488 4.28 1.464.849.96 1.273 2.594 1.273 4.903 0 2.31-.424 3.945-1.273 4.904-.834.944-2.26 1.416-4.28 1.416-2.034 0-3.476-.472-4.325-1.416-.834-.96-1.25-2.594-1.25-4.904 0-2.325.416-3.968 1.25-4.928.85-.96 2.29-1.44 4.325-1.44Zm0 2.708c-.864 0-1.442.244-1.734.732-.293.488-.44 1.464-.44 2.927 0 1.432.147 2.391.44 2.88.292.487.87.731 1.734.731.834 0 1.397-.244 1.69-.732.307-.488.461-1.447.461-2.879 0-1.447-.146-2.415-.44-2.903-.292-.504-.862-.756-1.711-.756ZM64.341 19.534H63.31c.102.732.153 1.334.153 1.806v3.781h-3.248V8.043h3.248v7.05c0 .798-.05 1.53-.153 2.197h1.01l2.678-4.197h3.643l-2.81 4.172a3.44 3.44 0 0 1-1.01 1.147v.049c.367.276.703.707 1.01 1.293l3.184 5.367H67.37l-3.03-5.587ZM72.719 15.777l-.307-2.44a28.679 28.679 0 0 1 5.641-.585c1.463 0 2.54.333 3.227 1 .688.65 1.032 1.79 1.032 3.416v7.953h-2.569l-.329-1.83c-1.083 1.415-2.415 2.123-3.995 2.123-1.04 0-1.888-.3-2.546-.903-.659-.618-.988-1.472-.988-2.561v-1.22c0-.96.292-1.708.878-2.245.585-.537 1.397-.805 2.436-.805h3.864v-.537c-.015-.618-.147-1.033-.395-1.244-.235-.211-.695-.317-1.383-.317-1.2 0-2.722.065-4.566.195Zm2.37 5.221v.464c0 .83.425 1.244 1.274 1.244.878 0 1.778-.39 2.7-1.171V19.85h-2.92c-.702.017-1.053.399-1.053 1.147ZM88.137 8.043v13.15c0 .813.41 1.22 1.23 1.22h.877l.374 2.513c-.556.325-1.42.488-2.59.488-.967 0-1.728-.285-2.284-.854-.556-.585-.834-1.407-.834-2.464V8.043h3.227ZM104.25 20.705h-5.203l-1.097 4.416h-3.425l4.369-15.858a1.18 1.18 0 0 1 .417-.708 1.15 1.15 0 0 1 .746-.268h3.161c.629 0 1.017.325 1.163.976l4.369 15.858h-3.403l-1.097-4.416Zm-.725-2.879-1.273-5.148c-.175-.813-.278-1.341-.307-1.585h-.593a36.09 36.09 0 0 1-.329 1.585l-1.273 5.148h3.775ZM112.753 13.093l.242 1.757c.454-.602 1.076-1.098 1.866-1.488.805-.39 1.617-.586 2.436-.586 2.488 0 3.732 2.147 3.732 6.441 0 2.31-.337 3.928-1.01 4.855-.658.911-1.697 1.367-3.117 1.367-1.463 0-2.67-.39-3.622-1.172.073.83.095 1.692.066 2.587v2.903h-3.227V13.093h2.634Zm.593 3.66v5.514c1.142.325 1.961.488 2.459.488.717 0 1.207-.228 1.47-.683.278-.456.417-1.407.417-2.855 0-1.415-.124-2.366-.373-2.854-.248-.505-.687-.757-1.317-.757-.717 0-1.602.383-2.656 1.147ZM125.916 13.093l.241 1.757c.454-.602 1.076-1.098 1.866-1.488.805-.39 1.617-.586 2.437-.586 2.487 0 3.731 2.147 3.731 6.441 0 2.31-.336 3.928-1.01 4.855-.658.911-1.697 1.367-3.117 1.367-1.463 0-2.67-.39-3.622-1.172.074.83.096 1.692.066 2.587v2.903h-3.227V13.093h2.635Zm.592 3.66v5.514c1.142.325 1.961.488 2.459.488.717 0 1.207-.228 1.471-.683.278-.456.417-1.407.417-2.855 0-1.415-.125-2.366-.374-2.854-.248-.505-.687-.757-1.317-.757-.717 0-1.602.383-2.656 1.147Z"
				/>
				<path
					fill="#FB0"
					d="M15 30H1.875A1.875 1.875 0 0 1 0 28.125V15A14.907 14.907 0 0 1 4.394 4.393 14.906 14.906 0 0 1 15 0a14.906 14.906 0 0 1 10.607 4.394A14.905 14.905 0 0 1 30 15a14.908 14.908 0 0 1-4.394 10.607A14.907 14.907 0 0 1 15 30Zm-.254-23.772a8.757 8.757 0 0 0-8.747 8.747 8.756 8.756 0 0 0 8.747 8.746 8.756 8.756 0 0 0 8.746-8.746 8.756 8.756 0 0 0-8.745-8.747h-.001Zm-1.313 12.247a.44.44 0 0 1-.44-.438v-6.123a.44.44 0 0 1 .44-.439c.095 0 .186.032.261.089l4.085 3.061a.43.43 0 0 1 0 .7l-4.085 3.061a.428.428 0 0 1-.258.09h-.002Z"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h95v30H0z" />
				</clipPath>
			</defs>
		</svg>
	),
	rightarrow: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={18}
			height={18}
			fill="none"
			role={"img"}
			aria-hidden={true}
			{...props}
		>
			<mask
				id="a"
				width={18}
				height={18}
				x={0}
				y={0}
				maskUnits="userSpaceOnUse"
				style={{
					maskType: "alpha",
				}}
			>
				<path fill="#D9D9D9" d="M0 0h18v18H0z" />
			</mask>
			<g mask="url(#a)">
				<path
					fill="#0174D3"
					d="M10.856 9 5.343 3.487a.878.878 0 0 1-.271-.665.944.944 0 0 1 .29-.666.91.91 0 0 1 .666-.281.91.91 0 0 1 .665.281l5.757 5.775c.15.15.262.319.337.506.075.188.113.376.113.563 0 .188-.038.375-.113.563a1.5 1.5 0 0 1-.337.506l-5.775 5.775a.867.867 0 0 1-.657.272.934.934 0 0 1-.656-.291.91.91 0 0 1-.281-.666.91.91 0 0 1 .281-.665L10.856 9Z"
				/>
			</g>
		</svg>
	),
	loadingIcon: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			role={"img"}
			aria-hidden={true}
			fill="none"
			className="animate-spin -ml-1 mr-3 text-sectionblue w-auto h-5 md:h-8"
			viewBox="0 0 24 24"
			{...props}
		>
			<circle
				cx={12}
				cy={12}
				r={10}
				stroke="currentColor"
				strokeWidth={4}
				className="opacity-25"
			/>
			<path
				fill="currentColor"
				d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
				className="opacity-75"
			/>
		</svg>
	),
	menuIcon: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={40}
			height={40}
			aria-hidden={true}
			role={"img"}
			fill="none"
			{...props}
		>
			<g clipPath="url(#a)">
				<mask
					id="b"
					width={24}
					height={24}
					x={8}
					y={8}
					maskUnits="userSpaceOnUse"
					style={{
						maskType: "alpha",
					}}
				>
					<path fill="#D9D9D9" d="M8 8h24v24H8z" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#1C1B1F"
						d="M12 26a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 25c0-.283.096-.52.287-.712A.968.968 0 0 1 12 24h16c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 28 26H12Zm0-5a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 20c0-.283.096-.52.287-.712A.968.968 0 0 1 12 19h16c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 28 21H12Zm0-5a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11 15c0-.283.096-.52.287-.713A.968.968 0 0 1 12 14h16c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 28 16H12Z"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="a">
					<rect width={40} height={40} fill="#fff" rx={20} />
				</clipPath>
			</defs>
		</svg>
	),

	okIcon: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={67}
			height={68}
			aria-hidden={true}
			role={"img"}
			fill="none"
			{...props}
		>
			<path
				fill="#1A9911"
				d="M33.5.667C15.1.667.167 15.6.167 34S15.1 67.333 33.5 67.333 66.833 52.4 66.833 34 51.9.667 33.5.667ZM24.466 48.3 12.5 36.333a3.32 3.32 0 0 1 0-4.7c1.3-1.3 3.4-1.3 4.7 0l9.633 9.6L49.767 18.3c1.3-1.3 3.4-1.3 4.7 0 1.3 1.3 1.3 3.4 0 4.7l-25.3 25.3c-1.267 1.3-3.4 1.3-4.7 0Z"
			/>
		</svg>

	),

	crossIcon: ({ ...props }: LucideProps) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={40}
			height={40}
			fill="none"
			{...props}
		>
			<g clipPath="url(#a)">
				<g clipPath="url(#b)">
					<path
						fill="#323232"
						d="M26.3 13.71a.996.996 0 0 0-1.41 0L20 18.59l-4.89-4.89a.996.996 0 1 0-1.41 1.41L18.59 20l-4.89 4.89a.996.996 0 1 0 1.41 1.41L20 21.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L21.41 20l4.89-4.89c.38-.38.38-1.02 0-1.4Z"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="a">
					<rect width={40} height={40} fill="#fff" rx={20} />
				</clipPath>
				<clipPath id="b">
					<path fill="#fff" d="M8 8h24v24H8z" />
				</clipPath>
			</defs>
		</svg>

	),
	faqIcon: ({ ...props }: LucideProps) => (
		<svg viewBox="64 64 896 896" focusable="false" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true" {...props}>
			<path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" />
		</svg>
	)
}
